export default __webpack_public_path__ + "static/media/定级峰会VIP.e75fc43c.png";